import cx from 'classnames'
import React from 'react'
import { FieldRenderProps } from 'react-final-form'

import { TEXTUAL_OPTIONS } from '@cinch/oxd-pages/lifestyle/src/constants'

import * as styles from './bubble-field.module.css'

const BubbleField: React.FC<FieldRenderProps> = ({ input }) => {
  const value = new Set(input.value || [])
  const isActive = (id: string) => value.has(id)
  const onClick = (id: string) => {
    value.has(id) ? value.delete(id) : value.add(id)
    input.onChange({ target: { value: Array.from(value) } })
  }

  return (
    <div className={styles.list}>
      {TEXTUAL_OPTIONS.map((item) => (
        <button
          key={item.id}
          type="button"
          role="switch"
          aria-checked={isActive(item.id)}
          onClick={() => onClick(item.id)}
          className={cx(styles.button, { [styles.active]: isActive(item.id) })}
        >
          {item.label}
        </button>
      ))}
    </div>
  )
}

export default BubbleField
